import * as yup from "yup";

export const callbackFormInputSchema = yup
  .object({
    name: yup
      .string()
      .required("Please enter your name")
      .min(4, "Please enter full name"),
    countryCode: yup.string().required().default("+91"),
    mobile: yup
      .string()
      .required("Please enter a valid phone number")
      .min(8, "Number should be minimum 8 characters")
      .max(14, "Number should be maximum 14 characters"),
  })
  .required();
